export default __webpack_public_path__ + "static/media/NAVMII.39e5e4f1.png";